module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/components/ticketNotification/ticketNotification.html
// module id = 1001
// module chunks = 0